import { appConfig } from "@/constants";
import { logger } from "./logger";

export async function fetcher<JSON = unknown>(
  input: RequestInfo,
  init?: RequestInit,
): Promise<JSON> {
  const response = await fetch(input, {
    headers: {
      "Content-Type": "application/json",
    },
    ...init,
  });

  if (!response.ok) {
    throw `HTTP ${response.status} - ${input}`;
  }
  return response.json();
}

export const apiFetcher = async (path: string) => {
  const fullUrl = appConfig.IMMUTABLE_BASE_URI + path;

  try {
    const res = await fetch(fullUrl);

    if (!res.ok) {
      const errorMsg = `HTTP ${res.status} - ${fullUrl}`;
      logger.error(errorMsg);
      throw errorMsg;
    }

    return await res.json();
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
